import React, { useState, useRef, useEffect } from 'react';
import Loading from '../../Global/Loading';
import CRPBlockWrapper from './CRPBlockWrapper';
import FaEdit from 'react-icons/lib/fa/pencil';
import FaSave from 'react-icons/lib/fa/floppy-o';

const BLOCK_TITLE = "Score";

export default function CRPScoreBlock({ numerator, denominator, onAdjustScore }) {
  const [editing, setEditing] = useState(false);
  const [editedNumerator, setEditedNumerator] = useState(numerator);
  const inputRef = useRef(null);
  const saveButtonWrapperRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editing && inputRef.current) {
      setEditedNumerator(numerator);
      inputRef.current.focus();
      inputRef.current.select();

      inputRef.current.addEventListener('keypress', handleKeyPress);
    }
  }, [editing, numerator]);

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      saveButtonWrapperRef.current.click();
    }
  };

  function handleNumeratorChange(e) {
    setEditedNumerator(e.target.value);
  };

  async function onClickSave() {
    if (inputRef.current) {
      inputRef.current.removeEventListener('keypress', handleKeyPress);
    }
    setLoading(true);
    setEditing(false);
    await onAdjustScore(editedNumerator);
    setLoading(false);
  }

  return (
    <CRPBlockWrapper title={BLOCK_TITLE}>
      <div className='scoreBlock'>
        {loading && <Loading />}
        {!loading && !editing && (
          <>
            <div className='scoreInner'>{`${numerator}/${denominator}`}</div>
            <FaEdit size="24" className='editButtonIcon' onClick={() => setEditing(true)} />
          </>
        )}
        {!loading && editing && (
          <>
            <div className='scoreInner'>
              <input 
                type='number' 
                value={editedNumerator} 
                onChange={handleNumeratorChange}
                min={0}
                max={10}
                ref={inputRef}
              />
              {`/${denominator}`}
            </div>
            <div
              style={{ display: 'inline-block' }} // Add a wrapper div around the FaSave icon
              ref={saveButtonWrapperRef}
              onClick={onClickSave}
            >
              <FaSave size="24" className='editButtonIcon' />
            </div>
          </>
        )}
      </div>
    </CRPBlockWrapper>
  );
}
